export const bytesToWords = (bytes, bytesPerWord) => {
  return Math.round(bytes / bytesPerWord);
};
